import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import compressToolsIcon from '../assets/compresstools-icon.png';
import { trackPageView } from '../utils/analytics';

const CompressToolsPrivacy = () => {
  useEffect(() => {
    trackPageView('Compress Tools Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={compressToolsIcon} alt="Compress Tools" />
          </div>
          <div className="app-details">
            <h1>Compress Tools</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>Compress Tools does not collect, store, sell, or transmit any personal information, file contents, or usage data. We do not operate servers that receive your photos, videos, or any other files.</p>
        </div>

        <div className="privacy-section">
          <h2>Local Processing</h2>
          <p>All image and video compression, format conversion, and metadata removal happen entirely on your Mac. Your files are never uploaded anywhere and never leave your device.</p>
        </div>

        <div className="privacy-section">
          <h2>Local Storage</h2>
          <p>Your app preferences — such as default output folder, file naming, and compression quality settings — are stored locally on your device. Removing the app removes this locally stored content.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>Compress Tools does not include advertising networks, third-party analytics SDKs, or tracking technologies. The app operates completely offline.</p>
        </div>

        <div className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>Compress Tools does not knowingly collect personal information from children or any other users.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> August 2026</p>
        </div>
      </main>
    </div>
  );
};

export default CompressToolsPrivacy;
